/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { useLayoutEffect } from 'fierry/react';

import { getInstance } from 'solis/auth/firebase';


export default ({ config }) =>
{
  useLayoutEffect(() =>
  {
    getInstance().reset();
    getInstance().start('#firebase-auth-container', config);
  }, []);

  return <div id = 'firebase-auth-container' />;
};
